import { Location } from '@angular/common';
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CapacitorSwipeService {
    private _renderer: Renderer2;
    private _touchStartX = 0;
    private _touchStartY = 0;
    private _touchCurrentX = 0;
    private _touchCurrentY = 0;
    private _backIndicatorShown = false;
    private _scrollableElement = null;
    private _backIndicator = null;
    private readonly SWIPE_THRESHOLD = Math.max(150, Math.min(300, window.innerWidth * 0.25)); // swipe has to be min 150px and max 300px
    private readonly MAX_VERTICAL_DRIFT = 100;

    constructor(
        private _location: Location,
        private _rendererFactory: RendererFactory2
    ) {}

    public initListeners(): void {
        console.log(this.SWIPE_THRESHOLD);
        this._backIndicator = document.getElementById('swipe-back-indicator');
        this._renderer = this._rendererFactory.createRenderer(null, null);
        this._renderer.listen('document', 'touchstart', (e: TouchEvent) => this._onTouchStart(e));
        this._renderer.listen('document', 'touchmove', (e: TouchEvent) => this._onTouchMove(e));
        this._renderer.listen('document', 'touchend', (e: TouchEvent) => this._onTouchEnd(e));
    }

    private _onTouchStart(e: TouchEvent): void {
        if (e.touches.length !== 1) {
            return;
        }

        const touch = e.touches[0];
        this._touchStartX = touch.pageX;
        this._touchStartY = touch.pageY;
        this._touchCurrentX = this._touchStartX;
        this._touchCurrentY = this._touchStartY;
        this._backIndicatorShown = false;

        this._scrollableElement = this._findScrollableAncestor(e.target);
    }

    private _onTouchMove(e: TouchEvent): void {
        if (e.touches.length !== 1) {
            return;
        }

        const touch = e.touches[0];
        this._touchCurrentX = touch.pageX;
        this._touchCurrentY = touch.pageY;

        const diffX = this._touchCurrentX - this._touchStartX;
        const diffY = Math.abs(touch.pageY - this._touchStartY);

        const isSwipingRight = diffX > this.SWIPE_THRESHOLD && diffY < this.MAX_VERTICAL_DRIFT;

        const isScrollableAndAtStart =
            this._scrollableElement &&
            this._scrollableElement.scrollLeft === 0 &&
            diffX > 0;

        const allowSwipe =
            (!this._scrollableElement && isSwipingRight) ||
            (this._scrollableElement && isScrollableAndAtStart && isSwipingRight);

        if (allowSwipe) {
            if (!this._backIndicatorShown) {
                this._backIndicator.style.opacity = '1';
                this._backIndicatorShown = true;
            }
        } else {
            if (this._backIndicatorShown) {
                this._backIndicator.style.opacity = '0';
                this._backIndicatorShown = false;
            }
        }
    }

    private _onTouchEnd(e: TouchEvent): void {
        const diffX = this._touchCurrentX - this._touchStartX;
        const diffY = Math.abs(this._touchCurrentY - this._touchStartY);
        const isScrollableAndAtStart =
            this._scrollableElement &&
            this._scrollableElement.scrollLeft === 0 &&
            diffX > 0;

        if (diffX > this.SWIPE_THRESHOLD && diffY < this.MAX_VERTICAL_DRIFT) {
            if (!this._scrollableElement || (this._scrollableElement && isScrollableAndAtStart)) {
                this._location.back();
            }
        }

        this._backIndicator.style.opacity = '0';
        this._backIndicatorShown = false;
        this._scrollableElement = null;
    }

    private _findScrollableAncestor(el: any): HTMLElement {
        while (el && el !== document.body) {
            const style = window.getComputedStyle(el);
            const isScrollable =
                (style.overflowX === 'auto' || style.overflowX === 'scroll') &&
                el.scrollWidth > el.clientWidth;
            if (isScrollable) {
                return el;
            }
            el = el.parentElement;
        }
        return null;
    }
}
